import nestedComponentForm from 'formiojs/components/_classes/nested/NestedComponent.form';
import { CustomComponentType } from '../../../enums';
import {
	BaseEditDisplay,
	BaseEditForm,
	IBaseWidgetConfigurationEditFormOptions,
	BaseEditLogic,
	BaseEditApi,
	BaseEditConditional,
	BaseEditLayout
} from '../../configuration-components';

export default function (...extend: any) {
	return nestedComponentForm(
		[
			new BaseEditDisplay().getTab({
				components: { showAutoOpen: true }
			}),
			new BaseEditForm().getTab({ componentType: CustomComponentType.primaryBorrowerEntity } as IBaseWidgetConfigurationEditFormOptions),
			new BaseEditLogic().getTab({ ignore: true }),
			new BaseEditApi().getTab(),
			new BaseEditConditional().getTab(),
			new BaseEditLayout().getTab({ ignore: true })
		],
		...extend
	);
}
